import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Typography, Box, Paper, Divider, Stack } from '@mui/material';
import { useReactToPrint } from 'react-to-print';

const OfferLetter = () => {
  const { state } = useLocation();
  const { employeeData } = state || {};
  const componentRef = React.useRef();
  const navigate = useNavigate(); // <-- for back button

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `${employeeData?.name}_Offer_Letter`,
  });

  return (
    <Box sx={{ padding: 4, backgroundColor: "#f4f6f8", minHeight: "100vh" }}>
      <Paper
        ref={componentRef}
        elevation={3}
        sx={{
          margin: "0 auto",
          maxWidth: "800px",
          padding: "40px",
          backgroundColor: "#fff",
          borderRadius: "16px",
          boxShadow: "0 8px 30px rgba(0,0,0,0.1)",
        }}
      >
        {/* Header */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
          <img
            src="rectangle-9@2x.png"
            alt="Company Logo"
            style={{ height: 60 }}
          />
          <Box>
            <Typography variant="h6" sx={{ color: '#2f80ed', fontWeight: 600 }}>
              Maa Tara Tarini Multi gym
            </Typography>
            <Typography variant="body2" color="text.secondary">
              https://www.mttmgym.com | sagarparida29@gmail.com
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ mb: 3 }} />

        {/* Title */}
        <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 3, textAlign: 'center', color: '#2f80ed' }}>
          Offer Letter
        </Typography>

        {/* Body */}
        <Typography variant="body1" gutterBottom>
          <strong>Date:</strong> {new Date().toLocaleDateString()}
        </Typography>

        <Typography variant="body1" gutterBottom>
          <strong>To,</strong>
          <br />
          {employeeData?.name}
          <br />
          {employeeData?.email}
        </Typography>

        <Typography variant="body1" sx={{ mt: 2 }} paragraph>
          Dear <strong>{employeeData?.name}</strong>,
        </Typography>

        <Typography variant="body1" paragraph>
          We are delighted to offer you the position of <strong>{employeeData?.designation}</strong> at <strong>Maa Tara Tarini Multi gym</strong>.
        </Typography>

        <Typography variant="body1" paragraph>
          Your monthly salary will be <strong>₹{employeeData?.salary}</strong>. Your expected joining date is <strong>{employeeData?.joining_date}</strong>.
        </Typography>

        <Typography variant="body1" paragraph>
          We believe your experience and skills will be a valuable addition to our team. We are excited to have you join us and contribute to our growth and vision.
        </Typography>

        <Typography variant="body1" paragraph>
          Please sign and return a copy of this letter to confirm your acceptance of the offer.
        </Typography>

        <Box sx={{ mt: 6 }}>
          <Typography variant="body1" paragraph sx={{ mb: 1 }}>
            Sincerely,
          </Typography>
          <Box
            component="img"
            src={`${process.env.PUBLIC_URL || ""}/images/ChatGPT.png`}
            alt="Owner and proprietor signature"
            sx={{
              display: "block",
              maxWidth: "min(280px, 100%)",
              maxHeight: { xs: 100, sm: 120 },
              width: "auto",
              height: "auto",
              objectFit: "contain",
              objectPosition: "left center",
              mb: 1,
            }}
          />
          <Typography variant="body1" fontWeight="bold">
            Mr. Sagar Parida
          </Typography>
          <Typography variant="body2" sx={{ color: "text.secondary", mb: 0.5 }}>
            Owner & Proprietor
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Maa Tara Tarini Multi gym
          </Typography>
        </Box>

        {/* Signature line */}
        <Box sx={{ mt: 6 }}>
          <Divider sx={{ my: 2 }} />
          <Typography variant="body2" sx={{ mt: 1 }}>
            Employee Signature: _____________________________
          </Typography>
          <Typography variant="body2">
            Date: ____________________
          </Typography>
        </Box>
      </Paper>

      {/* Buttons */}
      <Box sx={{ textAlign: "center", mt: 4 }}>
        <Stack spacing={2} direction="row" justifyContent="center">
          <Button
            variant="outlined"
            onClick={() => navigate(-1)} // <-- Back
            sx={{
              borderColor: "#2f80ed",
              color: "#2f80ed",
              fontWeight: "bold",
              borderRadius: "8px",
              px: 4,
              py: 1.5,
              '&:hover': {
                backgroundColor: "#e3f2fd",
              },
            }}
          >
            Back
          </Button>

          <Button
            variant="contained"
            onClick={handlePrint}
            sx={{
              backgroundColor: "#2f80ed",
              color: "#fff",
              fontWeight: "bold",
              borderRadius: "8px",
              px: 4,
              py: 1.5,
              '&:hover': {
                backgroundColor: "#1c5fc1",
              },
            }}
          >
            Download as PDF
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};

export default OfferLetter;
